import { useEffect, useState } from 'react';
import { rechercherDestinataires } from '../api/messagerieApi';

/**
 * Les utilisateurs du site dont le nom ou l'adresse contient `terme` (deux
 * lettres au moins), demandés au serveur un instant après la frappe.
 *
 * Rend [{ nom, mail }] — vide tant qu'il n'y a rien à chercher ou si la
 * recherche échoue : le champ reste utilisable à la main.
 */
export default function useRechercheDestinataires(terme, { minimum = 2, delai = 250 } = {}) {
  const [resultats, setResultats] = useState([]);
  const recherche = (terme ?? '').trim();

  useEffect(() => {
    if (recherche.length < minimum) {
      setResultats([]);
      return undefined;
    }

    let vivant = true;
    const minuteur = setTimeout(async () => {
      try {
        const { data } = await rechercherDestinataires(recherche);
        if (vivant) setResultats((data ?? []).filter((d) => d?.mail));
      } catch {
        if (vivant) setResultats([]);
      }
    }, delai);

    return () => {
      vivant = false;
      clearTimeout(minuteur);
    };
  }, [recherche, minimum, delai]);

  return resultats;
}
